import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import router from '../router'
import { getToken } from '@/utils/auth'

export const base_file_url = 'https://image.ruilibest.com'// 线上 图片文件地址

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
})

// 并发 401 去重：避免多请求同时 401 时多次跳转 / 多次 toast
let isLoggingOut = false

function handleUnauthorized() {
  if (isLoggingOut) return
  isLoggingOut = true
  store.dispatch('FedLogOut').then(() => {
    const current = router.currentRoute || {}
    const redirect = current.fullPath && current.fullPath !== '/login'
      ? current.fullPath
      : undefined
    const target = redirect ? { path: '/login', query: { redirect } } : { path: '/login' }
    router.push(target).catch(() => {})
  }).finally(() => {
    // 跳转完成后允许下次再触发
    setTimeout(() => { isLoggingOut = false }, 1500)
  })
}

// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Authorization'] = getToken()
  }
  return config
}, error => Promise.reject(error))

// response拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      // 401: token 失效，静默跳转，不再 MessageBox 打扰用户
      if (res.code === 401) {
        handleUnauthorized()
        return Promise.reject('unauthorized')
      }
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject('error')
    }
    return response.data
  },
  error => {
    // HTTP 层 401（部分场景后端直接返 401 status code）
    if (error && error.response && error.response.status === 401) {
      handleUnauthorized()
      return Promise.reject(error)
    }
    // 诊断偶发 400：把出错的请求详情打到控制台(Network 里可能一闪而过看不到)
    const cfg = (error && error.config) || {}
    const resp = error && error.response
    console.error('[API ERROR]', {
      url: cfg.url,
      method: cfg.method,
      params: cfg.params,
      data: cfg.data,
      status: resp && resp.status,
      serverMessage: resp && resp.data && resp.data.message
    })
    // 优先展示后端真实错误信息，而不是笼统的 "Request failed with status code 400"
    const msg = (resp && resp.data && resp.data.message) || (error && error.message) || '请求失败'
    Message({
      message: msg,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js